import { CurrencyTypes } from "constants/widget";

import { intlPriceFormat, priceFormat } from "./mathUtils";

export const formatPriceRealCurrency = (exchangeRate, price, locale) => {
  // eslint-disable-next-line max-len
  if (!exchangeRate || !exchangeRate.code || !exchangeRate.numerator || !exchangeRate.denominator || price === null || price === undefined) {
    return "";
  }
  let convertedAmount = price;
  convertedAmount *= exchangeRate.numerator;
  convertedAmount /= exchangeRate.denominator;
  return intlPriceFormat(convertedAmount, 2, exchangeRate.code, locale, true);
};

export const formatPriceVirtualCurrency = (price, nbDecimal, symbol, locale) => (
  priceFormat(price, nbDecimal, symbol, locale)
);

export const formatPrice = (
  exchangeRate,
  price,
  nbDecimal,
  symbol,
  locale,
  currencyTypeToDisplay,
) => {
  const priceVirtualCurrency = currencyTypeToDisplay !== CurrencyTypes.REAL
    ? formatPriceVirtualCurrency(price, nbDecimal, symbol, locale)
    : null;

  const priceRealCurrency = currencyTypeToDisplay !== CurrencyTypes.VIRTUAL
    ? formatPriceRealCurrency(exchangeRate, price, locale)
    : null;

  if (currencyTypeToDisplay === CurrencyTypes.VIRTUAL_AND_REAL && priceRealCurrency) {
    return `${priceVirtualCurrency} (${priceRealCurrency})`;
  }

  return priceRealCurrency || priceVirtualCurrency;
};

export const formatAmounts = (amounts, exchangeRate, locale, currencyTypeToDisplay) => amounts.map((amountDict) => {
  const price = amountDict.currency_group === 1
    // eslint-disable-next-line max-len
    ? formatPrice(exchangeRate, Math.abs(amountDict.amount), amountDict.decimal_places, amountDict.symbol, locale, currencyTypeToDisplay)
    : priceFormat(Math.abs(amountDict.amount), amountDict.decimal_places, amountDict.symbol, locale);
  return `${amountDict.amount > 0 ? "+" : "-"} ${price}`;
}).join(" | ");
